import { createMutation, createQuery } from 'react-query-kit';

import * as Types from '../api/cms/flight-calculator.types';
import * as API from '../api/cms/flight-calculator';
import { queryClient } from 'src';

//
//

const key = 'flight-calculator';

const invalidateQueryFlightSettings = (merchantCode: string) => {
  queryClient.invalidateQueries({
    queryKey: useQueryFlightCalculatorSettingsGet.getKey({ merchantCode }),
  });
};

//

export const useQueryFlightCalculatorSettingsGet = createQuery<
  Types.FlightCalculatorSettingsResponse,
  Types.FlightCalculatorDefaultSettingsPayload
>({
  queryKey: [key],
  fetcher: (params) => API.getFlightCalculatorSettingsByMerchantCodeAPI(params),
});

//

export const useQueryDefaultFlightCalculatorSettingsGet = createQuery<
  Types.FlightCalculatorDefaultSettingsResponse,
  Types.FlightCalculatorDefaultSettingsPayload
>({
  queryKey: [key, 'default'],
  fetcher: (params) => API.getFlightCalculatorDefaultSettingsByMerchantCodeAPI(params),
});

//

// put
export const useMutationFlightCalculatorSettingsUpdate = createMutation<
  Types.FlightCalculatorSettingsResponse,
  Types.FlightCalculatorSettingsUpdatePayload
>({
  mutationKey: [key, 'update'],
  mutationFn: (params) => API.updateFlightCalculatorSettingsAPI(params),
  onSuccess: (_, variables) => invalidateQueryFlightSettings(variables.merchantCode),
});

//

export const useMutationFlightCalculatorSettingsSave = createMutation<
  Types.FlightCalculatorSettingsResponse,
  Types.FlightCalculatorSettingsSavePayload
>({
  mutationKey: [key, 'save'],
  mutationFn: (params) => API.saveFlightCalculatorSettingsAPI(params),
});